import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DashboardProvider } from '@providers/dashboard/dashboard'
import { AuthProvider } from '@providers/auth/auth';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { ASSETS } from '@env';
import { CampaignsProvider }  from '@providers/campaigns/campaigns';
import { CampaignActiveComponent } from '../../components/campaign-active/campaign-active';
import { UserInfoComponent } from '../../components/user-info/user-info';

@IonicPage()
@Component({
  selector: 'page-leaderboard',
  templateUrl: 'leaderboard.html',
})
export class LeaderboardPage implements AfterViewInit {

  leaderboard: any = {
    leaderboard: [],
    posiciones: [],
  };
  leaderboardRequest: Boolean = true;
  jugador: Jugador;
  equipo: Equipo;
  AVATAR_PLAYER = ASSETS.AVATAR_PLAYER;
  tab: string = 'campaign';
  campaign: any = null;
  @ViewChild('main', { read: ElementRef }) main: ElementRef;
  @ViewChild(CampaignActiveComponent) campaignComponent: CampaignActiveComponent;
  @ViewChild(UserInfoComponent) header: UserInfoComponent;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly dashboardProvider: DashboardProvider,
    private readonly authProvider: AuthProvider,
    private campaignsProvider: CampaignsProvider,
  ) {

  }

  ionViewDidLoad() {
    this.initRequest();
  }

  async ngAfterViewInit() {
    this.campaign = await this.campaignsProvider.get();
  }

  segmentChanged(ev) {
    this.initRequest();
  }

  async initRequest(refresher = null) {
    this.leaderboardRequest = true;
    try {
      this.jugador = await this.authProvider.getSession();
      this.equipo = await this.authProvider.getEquipo();

      await this._verificaCampania();

      if(!this.campaign) {
        this.tab = 'global';
      }
      this._updateScore();
      this.leaderboard = await this.dashboardProvider.leaderboard(this.equipo.area._id, this.jugador._id, this.tab == 'campaign' ? this.campaign._id: null);

    } catch (e) {
      console.log(e);
    } finally {
      this.leaderboardRequest = false;
      if ( refresher ) {
        refresher.complete();
      }
    }
  }

  private async _updateScore(){
    // try {
    //   await this.header.updateScore();
    // } catch( e ) {
    //   console.log('_updateScore', e);
    // }
  }

  private async _verificaCampania() {
    // await this.campaignComponent.init();
    await this.ngAfterViewInit();
    this.campaign = await this.campaignsProvider.get();
  }


  close() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/leaderboard/leaderboard.ts